import React from 'react';
import { ComponentProps, IconType } from './Icon.types';
import IconStyled from './Icon.styled';

const map: Map<ComponentProps['type'], (color: string) => JSX.Element> = new Map<
  IconType,
  (color: string) => JSX.Element
>([
  [
    'fileUpload',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path
          id="Vector"
          d="M9.84615 0C8.9077 0 8.00767 0.376274 7.34408 1.04605C6.68049 1.71582 6.30769 2.62423 6.30769 3.57143V7.5125C6.88602 7.34727 7.47831 7.23667 8.07692 7.18214V3.57143C8.07692 3.09783 8.26332 2.64362 8.59512 2.30874C8.92691 1.97385 9.37692 1.78571 9.84615 1.78571H15.1538V6.25C15.1538 6.9604 15.4334 7.64171 15.9311 8.14404C16.4288 8.64637 17.1038 8.92857 17.8077 8.92857H22.2308V21.4286C22.2308 21.9022 22.0444 22.3564 21.7126 22.6913C21.3808 23.0261 20.9308 23.2143 20.4615 23.2143H16.4684C15.913 23.8927 15.2704 24.4932 14.5576 25H20.4615C21.4 25 22.3 24.6237 22.9636 23.954C23.6272 23.2842 24 22.3758 24 21.4286V7.88214C23.9994 7.17198 23.7194 6.49113 23.2215 5.98929L18.066 0.783929C17.5685 0.28211 16.894 0.000151574 16.1906 0H9.84615ZM21.8645 7.14286H17.8077C17.5731 7.14286 17.3481 7.04879 17.1822 6.88135C17.0163 6.7139 16.9231 6.4868 16.9231 6.25V2.15536L21.8645 7.14286ZM16.9231 16.9643C16.9231 19.0955 16.0843 21.1394 14.5912 22.6464C13.0981 24.1534 11.0731 25 8.96154 25C6.85001 25 4.82496 24.1534 3.33188 22.6464C1.8388 21.1394 1 19.0955 1 16.9643C1 14.8331 1.8388 12.7892 3.33188 11.2822C4.82496 9.77519 6.85001 8.92857 8.96154 8.92857C11.0731 8.92857 13.0981 9.77519 14.5912 11.2822C16.0843 12.7892 16.9231 14.8331 16.9231 16.9643ZM9.84615 13.3929C9.84615 13.1561 9.75295 12.929 9.58706 12.7615C9.42116 12.5941 9.19615 12.5 8.96154 12.5C8.72692 12.5 8.50192 12.5941 8.33602 12.7615C8.17012 12.929 8.07692 13.1561 8.07692 13.3929V16.0714H5.42308C5.18846 16.0714 4.96346 16.1655 4.79756 16.3329C4.63166 16.5004 4.53846 16.7275 4.53846 16.9643C4.53846 17.2011 4.63166 17.4282 4.79756 17.5956C4.96346 17.7631 5.18846 17.8571 5.42308 17.8571H8.07692V20.5357C8.07692 20.7725 8.17012 20.9996 8.33602 21.1671C8.50192 21.3345 8.72692 21.4286 8.96154 21.4286C9.19615 21.4286 9.42116 21.3345 9.58706 21.1671C9.75295 20.9996 9.84615 20.7725 9.84615 20.5357V17.8571H12.5C12.7346 17.8571 12.9596 17.7631 13.1255 17.5956C13.2914 17.4282 13.3846 17.2011 13.3846 16.9643C13.3846 16.7275 13.2914 16.5004 13.1255 16.3329C12.9596 16.1655 12.7346 16.0714 12.5 16.0714H9.84615V13.3929Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'fileUploadHover',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path
          id="Vector"
          d="M14.1538 0V6.25C14.1538 6.9604 14.4334 7.64171 14.9311 8.14404C15.4288 8.64637 16.1038 8.92857 16.8077 8.92857H23V22.3214C23 23.0318 22.7204 23.7131 22.2227 24.2155C21.725 24.7178 21.05 25 20.3462 25H13.5576C15.4405 23.6671 16.7948 21.704 17.3803 19.4592C17.9657 17.2143 17.7444 14.8327 16.7557 12.7369C15.7669 10.641 14.0746 8.96636 11.979 8.01C9.88335 7.05365 7.51983 6.87739 5.30769 7.5125V2.67857C5.30769 1.96817 5.58729 1.28687 6.08499 0.784535C6.58268 0.282206 7.25769 0 7.96154 0H14.1538ZM15.9231 0.446429V6.25C15.9231 6.4868 16.0163 6.7139 16.1822 6.88135C16.3481 7.04879 16.5731 7.14286 16.8077 7.14286H22.5577L15.9231 0.446429ZM15.9231 16.9643C15.9231 19.0955 15.0843 21.1394 13.5912 22.6464C12.0981 24.1534 10.0731 25 7.96154 25C5.85001 25 3.82496 24.1534 2.33188 22.6464C0.838802 21.1394 0 19.0955 0 16.9643C0 14.8331 0.838802 12.7892 2.33188 11.2822C3.82496 9.77519 5.85001 8.92857 7.96154 8.92857C10.0731 8.92857 12.0981 9.77519 13.5912 11.2822C15.0843 12.7892 15.9231 14.8331 15.9231 16.9643ZM8.84615 13.3929C8.84615 13.1561 8.75295 12.929 8.58706 12.7615C8.42116 12.5941 8.19615 12.5 7.96154 12.5C7.72692 12.5 7.50192 12.5941 7.33602 12.7615C7.17012 12.929 7.07692 13.1561 7.07692 13.3929V16.0714H4.42308C4.18846 16.0714 3.96346 16.1655 3.79756 16.3329C3.63166 16.5004 3.53846 16.7275 3.53846 16.9643C3.53846 17.2011 3.63166 17.4282 3.79756 17.5956C3.96346 17.7631 4.18846 17.8571 4.42308 17.8571H7.07692V20.5357C7.07692 20.7725 7.17012 20.9996 7.33602 21.1671C7.50192 21.3345 7.72692 21.4286 7.96154 21.4286C8.19615 21.4286 8.42116 21.3345 8.58706 21.1671C8.75295 20.9996 8.84615 20.7725 8.84615 20.5357V17.8571H11.5C11.7346 17.8571 11.9596 17.7631 12.1255 17.5956C12.2914 17.4282 12.3846 17.2011 12.3846 16.9643C12.3846 16.7275 12.2914 16.5004 12.1255 16.3329C11.9596 16.1655 11.7346 16.0714 11.5 16.0714H8.84615V13.3929Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'view',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
        <path
          d="M10.498 2.58333C13.8143 2.58333 16.7718 5.06833 18.2155 9C16.7718 12.9317 13.823 15.4167 10.498 15.4167C7.17305 15.4167 4.2243 12.9317 2.78055 9C4.2243 5.06833 7.1818 2.58333 10.498 2.58333ZM10.498 0.25C6.12305 0.25 2.3868 3.87833 0.873047 9C2.3868 14.1217 6.12305 17.75 10.498 17.75C14.873 17.75 18.6093 14.1217 20.123 9C18.6093 3.87833 14.873 0.25 10.498 0.25ZM10.498 6.08333C11.7055 6.08333 12.6855 7.39 12.6855 9C12.6855 10.61 11.7055 11.9167 10.498 11.9167C9.29055 11.9167 8.31055 10.61 8.31055 9C8.31055 7.39 9.29055 6.08333 10.498 6.08333ZM10.498 3.75C8.32805 3.75 6.56055 6.10667 6.56055 9C6.56055 11.8933 8.32805 14.25 10.498 14.25C12.668 14.25 14.4355 11.8933 14.4355 9C14.4355 6.10667 12.668 3.75 10.498 3.75Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'warningOutline',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5 0C5.5971 0 0 5.5971 0 12.5C0 19.4029 5.5971 25 12.5 25C19.4029 25 25 19.4029 25 12.5C25 5.5971 19.4029 0 12.5 0ZM11.6071 6.47321C11.6071 6.35045 11.7076 6.25 11.8304 6.25H13.1696C13.2924 6.25 13.3929 6.35045 13.3929 6.47321V14.0625C13.3929 14.1853 13.2924 14.2857 13.1696 14.2857H11.8304C11.7076 14.2857 11.6071 14.1853 11.6071 14.0625V6.47321ZM12.5 18.75C12.1495 18.7428 11.8158 18.5986 11.5705 18.3482C11.3252 18.0978 11.1878 17.7613 11.1878 17.4107C11.1878 17.0602 11.3252 16.7236 11.5705 16.4732C11.8158 16.2228 12.1495 16.0786 12.5 16.0714C12.8505 16.0786 13.1842 16.2228 13.4295 16.4732C13.6748 16.7236 13.8122 17.0602 13.8122 17.4107C13.8122 17.7613 13.6748 18.0978 13.4295 18.3482C13.1842 18.5986 12.8505 18.7428 12.5 18.75Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'documentOutline',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5 0.00139025C15.8246 -0.0486042 19.0243 1.25125 21.3365 3.66348C23.7487 5.97572 25.0486 9.17537 24.9986 12.5C25.0486 15.8246 23.7487 19.0243 21.324 21.3365C19.0118 23.7487 15.8246 25.0486 12.5 24.9986C9.17537 25.0486 5.97572 23.7487 3.66348 21.324C1.25125 19.0118 -0.0486042 15.8246 0.00139025 12.5C-0.0486042 9.17537 1.25125 5.97572 3.67598 3.66348C5.98822 1.25125 9.17537 -0.0486042 12.5 0.00139025ZM14.2857 6.14286V3.57143L16.6667 5.35714L19.0476 7.14286H15.2857C14.7334 7.14286 14.2857 6.69514 14.2857 6.14286ZM8.14282 3.57144C7.59054 3.57144 7.14282 4.01915 7.14282 4.57143V19.2381C7.14282 19.7904 7.59054 20.2381 8.14282 20.2381H18.0476C18.5999 20.2381 19.0476 19.7904 19.0476 19.2381V9.33334C19.0476 8.78106 18.5999 8.33334 18.0476 8.33334H14.0952C13.5429 8.33334 13.0952 7.88562 13.0952 7.33334V4.57144C13.0952 4.01915 12.6475 3.57144 12.0952 3.57144H8.14282ZM9.0238 11.8069C9.0238 11.5308 9.24766 11.3069 9.5238 11.3069H16.6667C16.9428 11.3069 17.1667 11.5308 17.1667 11.8069C17.1667 12.0831 16.9428 12.3069 16.6667 12.3069H9.5238C9.24766 12.3069 9.0238 12.0831 9.0238 11.8069ZM9.0238 14.1879C9.0238 13.9117 9.24766 13.6879 9.5238 13.6879H16.6667C16.9428 13.6879 17.1667 13.9117 17.1667 14.1879C17.1667 14.464 16.9428 14.6879 16.6667 14.6879H9.5238C9.24766 14.6879 9.0238 14.464 9.0238 14.1879ZM9.0238 16.5688C9.0238 16.2927 9.24766 16.0688 9.5238 16.0688H16.6667C16.9428 16.0688 17.1667 16.2927 17.1667 16.5688C17.1667 16.845 16.9428 17.0688 16.6667 17.0688H9.5238C9.24766 17.0688 9.0238 16.845 9.0238 16.5688Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'phoneOutline',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5 0.00139025C15.8246 -0.0486042 19.0243 1.25125 21.3365 3.66348C23.7487 5.97573 25.0486 9.17537 24.9986 12.5C25.0486 15.8246 23.7487 19.0243 21.324 21.3365C19.0118 23.7487 15.8246 25.0486 12.5 24.9986C9.17537 25.0486 5.97573 23.7487 3.66348 21.324C1.25125 19.0118 -0.0486042 15.8246 0.00139025 12.5C-0.0486042 9.17537 1.25125 5.97573 3.67598 3.66348C5.98822 1.25125 9.17537 -0.0486042 12.5 0.00139025ZM14.9227 10.9662C15.0927 11.1369 15.3037 11.2222 15.5556 11.2222C15.8074 11.2222 16.0184 11.1369 16.1884 10.9662C16.3591 10.7961 16.4444 10.5852 16.4444 10.3333V5.88889C16.4444 5.63704 16.3591 5.42578 16.1884 5.25511C16.0184 5.08504 15.8074 5 15.5556 5C15.3037 5 15.0927 5.08504 14.9227 5.25511C14.752 5.42578 14.6667 5.63704 14.6667 5.88889V10.3333C14.6667 10.5852 14.752 10.7961 14.9227 10.9662ZM18.4782 10.9662C18.6483 11.1369 18.8593 11.2222 19.1111 11.2222C19.363 11.2222 19.5739 11.1369 19.744 10.9662C19.9147 10.7961 20 10.5852 20 10.3333V5.88889C20 5.63704 19.9147 5.42578 19.744 5.25511C19.5739 5.08504 19.363 5 19.1111 5C18.8593 5 18.6483 5.08504 18.4782 5.25511C18.3076 5.42578 18.2222 5.63704 18.2222 5.88889V10.3333C18.2222 10.5852 18.3076 10.7961 18.4782 10.9662ZM13.4782 19.7218C15.2927 20.5739 17.1556 21 19.0667 21C19.3333 21 19.5556 20.9111 19.7333 20.7333C19.9111 20.5556 20 20.3333 20 20.0667V16.4667C20 16.2593 19.9333 16.0776 19.8 15.9218C19.6667 15.7665 19.4963 15.6667 19.2889 15.6222L16.2222 15C16.0148 14.9704 15.8039 14.9887 15.5893 15.0551C15.3742 15.1221 15.2 15.2222 15.0667 15.3556L12.9778 17.4444C11.8519 16.763 10.8222 15.9556 9.88889 15.0222C8.95556 14.0889 8.17778 13.0889 7.55556 12.0222L9.68889 9.84444C9.82222 9.71111 9.90756 9.55911 9.94489 9.38844C9.98163 9.21837 9.98519 9.02963 9.95556 8.82222L9.37778 5.71111C9.34815 5.5037 9.25185 5.33333 9.08889 5.2C8.92593 5.06667 8.74074 5 8.53333 5H4.93333C4.66667 5 4.44444 5.08889 4.26667 5.26667C4.08889 5.44444 4 5.66667 4 5.93333C4 7.84444 4.42607 9.70726 5.27822 11.5218C6.12978 13.3369 7.2557 14.9443 8.656 16.344C10.0557 17.7443 11.6631 18.8702 13.4782 19.7218Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'homeOutline',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3365 4.16348C19.0243 1.75125 15.8246 0.451396 12.5 0.50139C9.17537 0.451396 5.98822 1.75125 3.67598 4.16348C1.25125 6.47573 -0.0486042 9.67537 0.00139025 13C-0.0486042 16.3246 1.25125 19.5118 3.66348 21.824C5.97573 24.2487 9.17537 25.5486 12.5 25.4986C15.8246 25.5486 19.0118 24.2487 21.324 21.8365C23.7487 19.5243 25.0486 16.3246 24.9986 13C25.0486 9.67537 23.7487 6.47573 21.3365 4.16348ZM18.7493 13V20.4992H14.3748V14.2499H10.6252V20.4992H6.2507V13H3.75097L12.5 4.25097L21.874 13H18.7493Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'successShield',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="31" viewBox="0 0 25 31" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.4695 0L0 5.63636V14.0909C0 21.9114 5.32033 29.2245 12.4695 31C19.6187 29.2245 24.939 21.9114 24.939 14.0909V5.63636L12.4695 0ZM9.69851 22.5455L4.1565 16.9091L6.11006 14.9223L9.69851 18.5577L18.829 9.27182L20.7825 11.2727L9.69851 22.5455Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'mailOutline',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5 0.50139C15.8246 0.451396 19.0243 1.75125 21.3365 4.16348C23.7488 6.47573 25.0486 9.67537 24.9986 13C25.0486 16.3246 23.7487 19.5243 21.324 21.8365C19.0118 24.2487 15.8246 25.5486 12.5 25.4986C9.17537 25.5486 5.97573 24.2487 3.66348 21.824C1.25125 19.5118 -0.0486042 16.3246 0.00139025 13C-0.0486042 9.67537 1.25125 6.47573 3.67598 4.16348C5.98822 1.75125 9.17537 0.451396 12.5 0.50139ZM4.4998 19.9864C4.83243 20.3288 5.2325 20.5 5.7 20.5H19.3C19.7675 20.5 20.1679 20.3288 20.5011 19.9864C20.8337 19.6434 21 19.2312 21 18.75V8.25C21 7.76875 20.8337 7.35692 20.5011 7.0145C20.1679 6.6715 19.7675 6.5 19.3 6.5H5.7C5.2325 6.5 4.83243 6.6715 4.4998 7.0145C4.1666 7.35692 4 7.76875 4 8.25V18.75C4 19.2312 4.1666 19.6434 4.4998 19.9864ZM19.3 10L12.5 14.375L5.7 10V8.25L12.5 12.625L19.3 8.25V10Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'poundOutline',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
        <g clip-path="url(#clip0_1811_22171)">
          <path
            d="M12.5 25.5C5.59625 25.5 0 19.9037 0 13C0 6.09625 5.59625 0.5 12.5 0.5C19.4037 0.5 25 6.09625 25 13C25 19.9037 19.4037 25.5 12.5 25.5ZM8.75 14.25V16.75H7.5V19.25H17.5V16.75H11.25V14.25H15V11.75H11.25V10.5C11.2497 10.0951 11.3804 9.70105 11.6227 9.37666C11.865 9.05228 12.2057 8.81502 12.594 8.70036C12.9823 8.5857 13.3973 8.59981 13.7769 8.74056C14.1565 8.88132 14.4803 9.14116 14.7 9.48125L17.1825 8.86125C16.8015 7.92037 16.1052 7.14122 15.2129 6.6572C14.3206 6.17318 13.2879 6.0144 12.2914 6.20805C11.2949 6.4017 10.3968 6.93573 9.75073 7.7187C9.10468 8.50168 8.75091 9.4849 8.75 10.5V11.75H7.5V14.25H8.75Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_1811_22171">
            <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </IconStyled>
    ),
  ],
  [
    'arrowRightRounded',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M10.7 13.3L13.3 10.7C13.5 10.5 13.6 10.2667 13.6 10C13.6 9.73333 13.5 9.5 13.3 9.3L10.675 6.675C10.4917 6.49167 10.2627 6.404 9.988 6.412C9.71267 6.42067 9.48333 6.51667 9.3 6.7C9.11667 6.88333 9.025 7.11667 9.025 7.4C9.025 7.68333 9.11667 7.91667 9.3 8.1L10.2 9H6.975C6.69167 9 6.45833 9.09567 6.275 9.287C6.09167 9.479 6 9.71667 6 10C6 10.2833 6.096 10.5207 6.288 10.712C6.47933 10.904 6.71667 11 7 11H10.2L9.275 11.925C9.09167 12.1083 9.004 12.3377 9.012 12.613C9.02067 12.8877 9.11667 13.1167 9.3 13.3C9.48333 13.4833 9.71667 13.575 10 13.575C10.2833 13.575 10.5167 13.4833 10.7 13.3ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2167 18 14.1043 17.221 15.663 15.663C17.221 14.1043 18 12.2167 18 10C18 7.78333 17.221 5.89567 15.663 4.337C14.1043 2.779 12.2167 2 10 2C7.78333 2 5.896 2.779 4.338 4.337C2.77933 5.89567 2 7.78333 2 10C2 12.2167 2.77933 14.1043 4.338 15.663C5.896 17.221 7.78333 18 10 18Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'kebab',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 25" fill="none">
        <path
          d="M15.1043 12.5C15.1043 13.1906 14.83 13.853 14.3416 14.3414C13.8532 14.8298 13.1908 15.1041 12.5002 15.1041C11.8095 15.1041 11.1471 14.8298 10.6587 14.3414C10.1704 13.853 9.896 13.1906 9.896 12.5C9.896 11.8093 10.1704 11.1469 10.6587 10.6585C11.1471 10.1702 11.8095 9.8958 12.5002 9.8958C13.1908 9.8958 13.8532 10.1702 14.3416 10.6585C14.83 11.1469 15.1043 11.8093 15.1043 12.5ZM14.0627 12.5C14.0625 12.0854 13.8977 11.6879 13.6045 11.3949C13.3113 11.1019 12.9137 10.9373 12.4991 10.9375C12.0846 10.9376 11.6871 11.1024 11.3941 11.3956C11.101 11.6889 10.9365 12.0865 10.9366 12.501C10.9368 12.9155 11.1016 13.3131 11.3948 13.6061C11.688 13.8991 12.0856 14.0636 12.5002 14.0635C12.9147 14.0634 13.3122 13.8986 13.6052 13.6053C13.8983 13.3121 14.0628 12.9145 14.0627 12.5ZM15.1043 4.75309C15.1043 5.44376 14.83 6.10614 14.3416 6.59452C13.8532 7.08289 13.1908 7.35726 12.5002 7.35726C11.8095 7.35726 11.1471 7.08289 10.6587 6.59452C10.1704 6.10614 9.896 5.44376 9.896 4.75309C9.896 4.06242 10.1704 3.40004 10.6587 2.91167C11.1471 2.42329 11.8095 2.14893 12.5002 2.14893C13.1908 2.14893 13.8532 2.42329 14.3416 2.91167C14.83 3.40004 15.1043 4.06242 15.1043 4.75309V4.75309ZM14.0627 4.75309C14.0625 4.33855 13.8977 3.94105 13.6045 3.64802C13.3113 3.355 12.9137 3.19045 12.4991 3.19059C12.0846 3.19073 11.6871 3.35554 11.3941 3.64876C11.101 3.94198 10.9365 4.3396 10.9366 4.75413C10.9368 5.16867 11.1016 5.56618 11.3948 5.8592C11.688 6.15223 12.0856 6.31677 12.5002 6.31663C12.9147 6.3165 13.3122 6.15169 13.6052 5.85847C13.8983 5.56525 14.0628 5.16763 14.0627 4.75309V4.75309ZM15.1043 20.2468C15.1043 20.9375 14.83 21.5999 14.3416 22.0883C13.8532 22.5766 13.1908 22.851 12.5002 22.851C11.8095 22.851 11.1471 22.5766 10.6587 22.0883C10.1704 21.5999 9.896 20.9375 9.896 20.2468C9.896 19.5562 10.1704 18.8938 10.6587 18.4054C11.1471 17.917 11.8095 17.6427 12.5002 17.6427C13.1908 17.6427 13.8532 17.917 14.3416 18.4054C14.83 18.8938 15.1043 19.5562 15.1043 20.2468ZM14.0627 20.2468C14.0625 19.8323 13.8977 19.4348 13.6045 19.1418C13.3113 18.8487 12.9137 18.6842 12.4991 18.6843C12.0846 18.6845 11.6871 18.8493 11.3941 19.1425C11.101 19.4357 10.9365 19.8333 10.9366 20.2479C10.9368 20.6624 11.1016 21.0599 11.3948 21.353C11.688 21.646 12.0856 21.8105 12.5002 21.8104C12.9147 21.8102 13.3122 21.6454 13.6052 21.3522C13.8983 21.059 14.0628 20.6614 14.0627 20.2468V20.2468Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'pen',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 25" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25ZM17.2944 6.29248L17.1711 6.4158C16.9435 6.21279 16.6491 6.10067 16.3441 6.10082C16.0391 6.10097 15.7449 6.21339 15.5175 6.41662C15.2809 6.20532 14.9725 6.09256 14.6555 6.10149C14.3384 6.11041 14.0368 6.24035 13.8126 6.46463L11.0864 9.18924C11.0479 9.22771 11.0174 9.27339 10.9966 9.32366C10.9758 9.37393 10.965 9.42781 10.965 9.48222C10.965 9.53664 10.9758 9.59052 10.9966 9.64079C11.0174 9.69106 11.0479 9.73674 11.0864 9.77521C11.1249 9.81369 11.1705 9.84421 11.2208 9.86503C11.2711 9.88585 11.325 9.89657 11.3794 9.89657C11.4338 9.89657 11.4877 9.88585 11.5379 9.86503C11.5882 9.84421 11.6339 9.81369 11.6724 9.77521L14.3969 7.04977C14.4658 6.98063 14.5569 6.93806 14.6541 6.92958C14.7513 6.9211 14.8484 6.94725 14.9282 7.00343L6.9483 14.9836C6.89546 15.0366 6.85799 15.103 6.83988 15.1756L6.01226 18.4862C5.99501 18.5555 5.99598 18.628 6.01507 18.6968C6.03416 18.7656 6.07072 18.8283 6.1212 18.8788C6.17169 18.9293 6.23437 18.9658 6.30316 18.9849C6.37196 19.004 6.44452 19.005 6.5138 18.9877L9.82428 18.1601C9.8972 18.1421 9.96387 18.1046 10.0171 18.0517L18.535 9.53271C18.7591 9.30859 18.8891 9.00721 18.8981 8.69036C18.9072 8.3735 18.7948 8.06518 18.5838 7.82859L18.7071 7.7061C18.7999 7.61333 18.8736 7.50319 18.9238 7.38197C18.9741 7.26074 19 7.13081 19 6.99958C19 6.86835 18.9742 6.7384 18.924 6.61715C18.8739 6.49589 18.8003 6.38571 18.7075 6.29289C18.6148 6.20007 18.5046 6.12643 18.3834 6.07618C18.2622 6.02592 18.1323 6.00004 18.001 6C17.8698 5.99996 17.7399 6.02577 17.6186 6.07595C17.4974 6.12614 17.3872 6.19971 17.2944 6.29248Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'time',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM11.78 7H11.72C11.32 7 11 7.32 11 7.72V12.44C11 12.79 11.18 13.12 11.49 13.3L15.64 15.79C15.98 15.99 16.42 15.89 16.62 15.55C16.83 15.21 16.72 14.76 16.37 14.56L12.5 12.26V7.72C12.5 7.32 12.18 7 11.78 7Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'error',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 13C11.45 13 11 12.55 11 12V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V12C13 12.55 12.55 13 12 13ZM13 17H11V15H13V17Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'accept',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 16.2L5.5 12.7C5.11 12.31 4.49 12.31 4.1 12.7C3.71 13.09 3.71 13.71 4.1 14.1L8.29 18.29C8.68 18.68 9.31 18.68 9.7 18.29L20.3 7.70001C20.69 7.31001 20.69 6.69001 20.3 6.30001C19.91 5.91001 19.29 5.91001 18.9 6.30001L9 16.2Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'arrowLeft',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'arrowRight',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 13H16.17L11.29 17.88C10.9 18.27 10.9 18.91 11.29 19.3C11.68 19.69 12.31 19.69 12.7 19.3L19.29 12.71C19.68 12.32 19.68 11.69 19.29 11.3L12.71 4.7C12.32 4.31 11.69 4.31 11.3 4.7C10.91 5.09 10.91 5.72 11.3 6.11L16.17 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'lock',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM9 8V6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'lockOutline',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M 16.285156 7.816406 L 15.15625 7.816406 L 15.15625 5.601562 C 15.15625 2.539062 12.621094 0.0546875 9.5 0.0546875 C 6.378906 0.0546875 3.84375 2.539062 3.84375 5.601562 L 3.84375 7.816406 L 2.714844 7.816406 C 1.46875 7.816406 0.453125 8.816406 0.453125 10.035156 L 0.453125 21.128906 C 0.453125 22.347656 1.46875 23.34375 2.714844 23.34375 L 16.285156 23.34375 C 17.53125 23.34375 18.546875 22.347656 18.546875 21.128906 L 18.546875 10.035156 C 18.546875 8.816406 17.53125 7.816406 16.285156 7.816406 Z M 6.105469 5.601562 C 6.105469 3.757812 7.621094 2.273438 9.5 2.273438 C 11.378906 2.273438 12.894531 3.757812 12.894531 5.601562 L 12.894531 7.816406 L 6.105469 7.816406 Z M 16.285156 21.128906 L 2.714844 21.128906 L 2.714844 10.035156 L 16.285156 10.035156 Z M 9.5 17.800781 C 10.746094 17.800781 11.761719 16.800781 11.761719 15.582031 C 11.761719 14.363281 10.746094 13.363281 9.5 13.363281 C 8.257812 13.363281 7.238281 14.363281 7.238281 15.582031 C 7.238281 16.800781 8.257812 17.800781 9.5 17.800781 Z M 9.5 17.800781 "
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'link',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 7H14C13.45 7 13 7.45 13 8C13 8.55 13.45 9 14 9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H14C13.45 15 13 15.45 13 16C13 16.55 13.45 17 14 17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM8 12C8 12.55 8.45 13 9 13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11H9C8.45 11 8 11.45 8 12ZM10 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H10C10.55 9 11 8.55 11 8C11 7.45 10.55 7 10 7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H10C10.55 17 11 16.55 11 16C11 15.45 10.55 15 10 15Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'attachMoney',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.8 10.9C9.53 10.31 8.8 9.7 8.8 8.75C8.8 7.66 9.81 6.9 11.5 6.9C12.92 6.9 13.63 7.44 13.89 8.3C14.01 8.7 14.34 9 14.76 9H15.06C15.72 9 16.19 8.35 15.96 7.73C15.54 6.55 14.56 5.57 13 5.19V4.5C13 3.67 12.33 3 11.5 3C10.67 3 10 3.67 10 4.5V5.16C8.06 5.58 6.5 6.84 6.5 8.77C6.5 11.08 8.41 12.23 11.2 12.9C13.7 13.5 14.2 14.38 14.2 15.31C14.2 16 13.71 17.1 11.5 17.1C9.85 17.1 9 16.51 8.67 15.67C8.52 15.28 8.18 15 7.77 15H7.49C6.82 15 6.35 15.68 6.6 16.3C7.17 17.69 8.5 18.51 10 18.83V19.5C10 20.33 10.67 21 11.5 21C12.33 21 13 20.33 13 19.5V18.85C14.95 18.48 16.5 17.35 16.5 15.3C16.5 12.46 14.07 11.49 11.8 10.9Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'warning',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.73 21H21.26C22.03 21 22.51 20.17 22.13 19.5L12.86 3.5C12.47 2.83 11.51 2.83 11.13 3.5L1.86 19.5C1.48 20.17 1.96 21 2.73 21ZM13 18H11V16H13V18ZM12 14C11.45 14 11 13.55 11 13V11C11 10.45 11.45 10 12 10C12.55 10 13 10.45 13 11V13C13 13.55 12.55 14 12 14Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'checkCircle',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 25" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 12.5C0 9.18479 1.31696 6.00537 3.66117 3.66117C6.00537 1.31696 9.18479 0 12.5 0C15.8152 0 18.9946 1.31696 21.3388 3.66117C23.683 6.00537 25 9.18479 25 12.5C25 15.8152 23.683 18.9946 21.3388 21.3388C18.9946 23.683 15.8152 25 12.5 25C9.18479 25 6.00537 23.683 3.66117 21.3388C1.31696 18.9946 0 15.8152 0 12.5H0ZM11.7867 17.85L18.9833 8.85333L17.6833 7.81333L11.5467 15.4817L7.2 11.86L6.13333 13.14L11.7867 17.8517V17.85Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'closeCircle',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.5 0C19.4125 0 25 5.5875 25 12.5C25 19.4125 19.4125 25 12.5 25C5.5875 25 0 19.4125 0 12.5C0 5.5875 5.5875 0 12.5 0ZM16.9875 6.25L12.5 10.7375L8.0125 6.25L6.25 8.0125L10.7375 12.5L6.25 16.9875L8.0125 18.75L12.5 14.2625L16.9875 18.75L18.75 16.9875L14.2625 12.5L18.75 8.0125L16.9875 6.25Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'resize',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 17H15V15H17V17ZM17 13H15V11H17V13ZM13 17H11V15H13V17ZM13 13H11V11H13V13ZM9 17H7V15H9V17ZM17 9H15V7H17V9Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'pound',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.1997 6.31663C13.612 6.07575 12.9615 6.03448 12.348 6.19917C11.7346 6.36385 11.1922 6.72537 10.8041 7.22821C10.4167 7.73024 10.2045 8.34541 10.2 8.9795V11.8759H14C14.6075 11.8759 15.1 12.3684 15.1 12.9759C15.1 13.5834 14.6075 14.0759 14 14.0759H10.2V16.4759C10.2 16.5169 10.1977 16.5579 10.1931 16.5987C10.1761 16.7501 10.1507 16.8999 10.1173 17.0475C10.9125 17.0447 11.7042 17.1756 12.4589 17.4361C12.4927 17.4478 12.5259 17.461 12.5583 17.4759C13.1989 17.7695 13.8953 17.9215 14.6 17.9215C15.3047 17.9215 16.0011 17.7695 16.6417 17.4759C17.1939 17.2228 17.8468 17.4653 18.1 18.0176C18.3531 18.5698 18.1106 19.2227 17.5583 19.4759C16.6301 19.9013 15.6211 20.1215 14.6 20.1215C13.5985 20.1215 12.6085 19.9096 11.695 19.5C11.0388 19.2808 10.3434 19.2029 9.65458 19.2718C9.19687 19.3176 8.74913 19.4274 8.32422 19.5972C8.05474 19.7691 7.76479 19.9098 7.45978 20.0154C6.92558 20.2003 6.33819 19.9502 6.10127 19.4369C5.86434 18.9237 6.05502 18.3144 6.54226 18.0278C6.77607 17.8902 7.01701 17.7665 7.26385 17.6571C7.38935 17.5623 7.5032 17.4518 7.60241 17.3278C7.81518 17.0618 7.95234 16.7438 7.99999 16.4073V14.0759H6.99999C6.39248 14.0759 5.89999 13.5834 5.89999 12.9759C5.89999 12.3684 6.39248 11.8759 6.99999 11.8759H7.99999V8.96926C8.00672 7.85227 8.38 6.76838 9.06246 5.88409C9.74491 4.9998 10.6988 4.36401 11.7776 4.0744C12.8564 3.78479 14.0005 3.85736 15.0341 4.28098C16.0676 4.70459 16.9335 5.45582 17.4988 6.41926C17.8062 6.94325 17.6306 7.61724 17.1066 7.92466C16.5826 8.23208 15.9086 8.05651 15.6012 7.53252C15.2798 6.98468 14.7874 6.55751 14.1997 6.31663Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'upload',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4H6C5.45 4 5 4.45 5 5ZM7.41 14H9V19C9 19.55 9.45 20 10 20H14C14.55 20 15 19.55 15 19V14H16.59C17.48 14 17.93 12.92 17.3 12.29L12.71 7.7C12.32 7.31 11.69 7.31 11.3 7.7L6.71 12.29C6.08 12.92 6.52 14 7.41 14Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'download',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 19C19 18.45 18.55 18 18 18L6 18C5.45 18 5 18.45 5 19C5 19.55 5.45 20 6 20L18 20C18.55 20 19 19.55 19 19ZM16.59 10L15 10L15 5C15 4.45 14.55 4 14 4L10 4C9.45 4 9 4.45 9 5L9 10L7.41 10C6.52 10 6.07 11.08 6.7 11.71L11.29 16.3C11.68 16.69 12.31 16.69 12.7 16.3L17.29 11.71C17.92 11.08 17.48 10 16.59 10Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'sort',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 7.60401L15.6039 9L11.4902 4.79087L7.39068 8.96962L6 7.50691L11.49 2L17 7.60401Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 15.396L7.39614 14L11.5098 18.2091L15.6093 14.0304L17 15.4931L11.51 21L6 15.396Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'calendar',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 13H13C12.45 13 12 13.45 12 14V17C12 17.55 12.45 18 13 18H16C16.55 18 17 17.55 17 17V14C17 13.45 16.55 13 16 13ZM16 3V4H8V3C8 2.45 7.55 2 7 2C6.45 2 6 2.45 6 3V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V3C18 2.45 17.55 2 17 2C16.45 2 16 2.45 16 3ZM18 20H6C5.45 20 5 19.55 5 19V9H19V19C19 19.55 18.55 20 18 20Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'iconLeft',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.705 16.875L11.125 12.295L15.705 7.705L14.295 6.295L8.295 12.295L14.295 18.295L15.705 16.875Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'iconRight',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.295 16.285L12.875 11.705L8.295 7.115L9.705 5.705L15.705 11.705L9.705 17.705L8.295 16.285Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'iconDown',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.41 8.58L12 13.17L16.59 8.58L18 10L12 16L6 10L7.41 8.58Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'iconUp',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.41 16.42L12 11.83L16.59 16.42L18 15L12 9L6 15L7.41 16.42Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'bullet',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="4" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'arrowDropDown',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.71001 11.71L11.3 14.3C11.69 14.69 12.32 14.69 12.71 14.3L15.3 11.71C15.93 11.08 15.48 10 14.59 10H9.41001C8.52001 10 8.08001 11.08 8.71001 11.71Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'arrowDropUp',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.2975 12.8825L12.7075 10.2925C12.3175 9.9025 11.6875 9.9025 11.2975 10.2925L8.70752 12.8825C8.07752 13.5125 8.52752 14.5925 9.41752 14.5925L14.5975 14.5925C15.4875 14.5925 15.9275 13.5125 15.2975 12.8825Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'arrowDropRight',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.71 15.29L14.3 12.7C14.3927 12.6075 14.4663 12.4976 14.5164 12.3766C14.5666 12.2557 14.5924 12.126 14.5924 11.995C14.5924 11.864 14.5666 11.7344 14.5164 11.6134C14.4663 11.4924 14.3927 11.3825 14.3 11.29L11.71 8.7C11.08 8.08 10 8.52 10 9.41V14.58C10 15.48 11.08 15.92 11.71 15.29Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'arrowDropLeft',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.29 8.71001L9.70001 11.3C9.6073 11.3925 9.53376 11.5024 9.48357 11.6234C9.43339 11.7444 9.40756 11.874 9.40756 12.005C9.40756 12.136 9.43339 12.2657 9.48357 12.3866C9.53376 12.5076 9.6073 12.6175 9.70001 12.71L12.29 15.3C12.92 15.93 14 15.48 14 14.59V9.41001C14 8.52001 12.92 8.08001 12.29 8.71001Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'phone',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.2652 15.5 20.5196 15.6054 20.7071 15.7929C20.8946 15.9804 21 16.2348 21 16.5V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21C15.4913 21 11.1673 19.2089 7.97918 16.0208C4.79107 12.8327 3 8.50868 3 4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H7.5C7.76522 3 8.01957 3.10536 8.20711 3.29289C8.39464 3.48043 8.5 3.73478 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.1 8.31 8.82 8.59L6.62 10.79Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'help',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.67 12.68 13.31 13.14 13.13 13.86C13.05 14.18 13 14.54 13 15H11V14.5C11 14.04 11.08 13.6 11.22 13.19C11.42 12.61 11.75 12.09 12.17 11.67L13.41 10.41C13.87 9.97 14.09 9.31 13.96 8.61C13.83 7.89 13.27 7.28 12.57 7.08C11.46 6.77 10.43 7.4 10.1 8.35C9.98 8.72 9.67 9 9.28 9H8.98C8.4 9 8 8.44 8.16 7.88C8.59 6.41 9.84 5.29 11.39 5.05C12.91 4.81 14.36 5.6 15.26 6.85C16.44 8.48 16.09 10.23 15.07 11.25Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'close',
    (color: string) => (
      <IconStyled width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.3.71a.996.996 0 00-1.41 0L7 5.59 2.11.7A.997.997 0 10.7 2.11L5.59 7 .7 11.89a.997.997 0 001.41 1.41L7 8.41l4.89 4.89a.997.997 0 001.41-1.41L8.41 7l4.89-4.89c.38-.38.38-1.02 0-1.4z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'account',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'home',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 19V14H14V19C14 19.55 14.45 20 15 20H18C18.55 20 19 19.55 19 19V12H20.7C21.16 12 21.38 11.43 21.03 11.13L12.67 3.6C12.29 3.26 11.71 3.26 11.33 3.6L2.97 11.13C2.63 11.43 2.84 12 3.3 12H5V19C5 19.55 5.45 20 6 20H9C9.55 20 10 19.55 10 19Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'exit',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.79 16.29C11.18 16.68 11.81 16.68 12.2 16.29L15.79 12.7C16.18 12.31 16.18 11.68 15.79 11.29L12.2 7.7C11.81 7.31 11.18 7.31 10.79 7.7C10.4 8.09 10.4 8.72 10.79 9.11L12.67 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13H12.67L10.79 14.88C10.4 15.27 10.41 15.91 10.79 16.29ZM19 3H5C3.89 3 3 3.9 3 5V8C3 8.55 3.45 9 4 9C4.55 9 5 8.55 5 8V6C5 5.45 5.45 5 6 5H18C18.55 5 19 5.45 19 6V18C19 18.55 18.55 19 18 19H6C5.45 19 5 18.55 5 18V16C5 15.45 4.55 15 4 15C3.45 15 3 15.45 3 16V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'declarations',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM9 17H6C5.45 17 5 16.55 5 16C5 15.45 5.45 15 6 15H9C9.55 15 10 15.45 10 16C10 16.55 9.55 17 9 17ZM9 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H9C9.55 11 10 11.45 10 12C10 12.55 9.55 13 9 13ZM9 9H6C5.45 9 5 8.55 5 8C5 7.45 5.45 7 6 7H9C9.55 7 10 7.45 10 8C10 8.55 9.55 9 9 9ZM18.7 11.12L15.53 14.29C15.14 14.68 14.5 14.68 14.11 14.29L12.7 12.87C12.31 12.48 12.31 11.85 12.7 11.46C13.09 11.07 13.72 11.07 14.11 11.46L14.82 12.17L17.29 9.7C17.68 9.31 18.31 9.31 18.7 9.7L18.71 9.71C19.09 10.1 19.09 10.74 18.7 11.12Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'productSelection',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 5V19H5V5H19ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3ZM11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'more',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'loan',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 6C12 5.45 11.55 5 11 5H5.82L6.48 1.82L6.5 1.59C6.5 1.28 6.37 1 6.17 0.79L5.38 0L0.44 4.94C0.17 5.21 0 5.59 0 6V12.5C0 13.33 0.67 14 1.5 14H8.25C8.87 14 9.4 13.62 9.63 13.09L11.89 7.8C11.96 7.63 12 7.44 12 7.25V6ZM22.5 10H15.75C15.13 10 14.6 10.38 14.37 10.91L12.11 16.2C12.04 16.37 12 16.56 12 16.75V18C12 18.55 12.45 19 13 19H18.18L17.52 22.18L17.5 22.42C17.5 22.73 17.63 23.01 17.83 23.22L18.62 24L23.56 19.06C23.83 18.79 24 18.41 24 18V11.5C24 10.67 23.33 10 22.5 10Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'applicants',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'income',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 18V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.89 6 10 6.9 10 8V16C10 17.1 10.89 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'expenditure',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 11.5V15.5C4 16.33 4.67 17 5.5 17C6.33 17 7 16.33 7 15.5V11.5C7 10.67 6.33 10 5.5 10C4.67 10 4 10.67 4 11.5ZM10 11.5V15.5C10 16.33 10.67 17 11.5 17C12.33 17 13 16.33 13 15.5V11.5C13 10.67 12.33 10 11.5 10C10.67 10 10 10.67 10 11.5ZM3.5 22H19.5C20.33 22 21 21.33 21 20.5C21 19.67 20.33 19 19.5 19H3.5C2.67 19 2 19.67 2 20.5C2 21.33 2.67 22 3.5 22ZM16 11.5V15.5C16 16.33 16.67 17 17.5 17C18.33 17 19 16.33 19 15.5V11.5C19 10.67 18.33 10 17.5 10C16.67 10 16 10.67 16 11.5ZM10.57 1.49001L2.67 5.65001C2.26 5.86001 2 6.29001 2 6.75001C2 7.44001 2.56 8.00001 3.25 8.00001H19.76C20.44 8.00001 21 7.44001 21 6.75001C21 6.29001 20.74 5.86001 20.33 5.65001L12.43 1.49001C11.85 1.18001 11.15 1.18001 10.57 1.49001Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'pensions',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'properties',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'additionalInfo',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'info',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_176_23254)">
          <path
            d="M37.5 19C37.5 29.2299 29.4286 37.5 19.5 37.5C9.57136 37.5 1.5 29.2299 1.5 19C1.5 8.77008 9.57136 0.5 19.5 0.5C29.4286 0.5 37.5 8.77008 37.5 19Z"
            stroke={color}
          />
          <path
            d="M17.056 11.48C17.056 12.992 18.016 14.048 19.744 14.048C21.4 14.048 22.384 12.992 22.384 11.48C22.384 9.896 21.424 8.816 19.744 8.816C18.016 8.816 17.056 9.896 17.056 11.48ZM21.856 15.56H17.488V29H21.856V15.56Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_176_23254">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </IconStyled>
    ),
  ],
  [
    'reviewAndSubmit',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2V16H3V19C3 20.66 4.34 22 6 22H18C19.66 22 21 20.66 21 19V2L19.5 3.5ZM19 19C19 19.55 18.55 20 18 20C17.45 20 17 19.55 17 19V16H8V5H19V19Z"
          fill={color}
        />
        <path d="M15 7H9V9H15V7Z" fill={color} />
        <path d="M18 7H16V9H18V7Z" fill={color} />
        <path d="M15 10H9V12H15V10Z" fill={color} />
        <path d="M18 10H16V12H18V10Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'calculator',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 2H17C17.5304 2 18.0391 2.21071 18.4142 2.58579C18.7893 2.96086 19 3.46957 19 4V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V4C5 3.46957 5.21071 2.96086 5.58579 2.58579C5.96086 2.21071 6.46957 2 7 2ZM7 4V8H17V4H7ZM7 10V12H9V10H7ZM11 10V12H13V10H11ZM15 10V12H17V10H15ZM7 14V16H9V14H7ZM11 14V16H13V14H11ZM15 14V16H17V14H15ZM7 18V20H9V18H7ZM11 18V20H13V18H11ZM15 18V20H17V18H15Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'checkbox',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.5 21H4.5C4.10252 20.9989 3.72163 20.8405 3.44057 20.5594C3.15951 20.2784 3.00111 19.8975 3 19.5V4.5C3.00111 4.10252 3.15951 3.72163 3.44057 3.44057C3.72163 3.15951 4.10252 3.00111 4.5 3H19.5C19.8975 3.00111 20.2784 3.15951 20.5594 3.44057C20.8405 3.72163 20.9989 4.10252 21 4.5V19.5C20.9989 19.8975 20.8405 20.2784 20.5594 20.5594C20.2784 20.8405 19.8975 20.9989 19.5 21Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </IconStyled>
    ),
  ],
  [
    'errorOutline',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM12 2C6.47 2 2 6.5 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'progressOutline',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 2.03V4.05C17.39 4.59 20.5 8.58 19.96 12.97C19.5 16.61 16.64 19.5 13 19.93V21.93C18.5 21.38 22.5 16.5 21.95 11C21.5 6.25 17.73 2.5 13 2.03ZM11 2.06C9.05 2.25 7.19 3 5.67 4.26L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2.06ZM4.26 5.67C3.00966 7.18734 2.24021 9.04308 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67ZM15.5 8.5L10.62 13.38L8.5 11.26L7.44 12.32L10.62 15.5L16.56 9.56L15.5 8.5ZM2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.80693 15.7696 4.24396 14.4226 4.06 13H2.06ZM7.1 18.37L5.67 19.74C7.18478 21.0027 9.03927 21.789 11 22V20C9.5774 19.816 8.23041 19.2531 7.1 18.37Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'successOutline',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'errorMark',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 4H13V15H11V4ZM13 18V20H11V18H13Z" fill={color} />
      </IconStyled>
    ),
  ],
  [
    'progress',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 2.03V4.05C17.39 4.59 20.5 8.58 19.96 12.97C19.5 16.61 16.64 19.5 13 19.93V21.93C18.5 21.38 22.5 16.5 21.95 11C21.5 6.25 17.73 2.5 13 2.03ZM11 2.06C9.05 2.25 7.19 3 5.67 4.26L7.1 5.74C8.22 4.84 9.57 4.26 11 4.06V2.06ZM4.26 5.67C3.00966 7.18734 2.24021 9.04308 2.05 11H4.05C4.24 9.58 4.8 8.23 5.69 7.1L4.26 5.67ZM2.06 13C2.26 14.96 3.03 16.81 4.27 18.33L5.69 16.9C4.80693 15.7696 4.24396 14.4226 4.06 13H2.06ZM7.1 18.37L5.67 19.74C7.18478 21.0027 9.03927 21.789 11 22V20C9.5774 19.816 8.23041 19.2531 7.1 18.37Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'twitter',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.533 7.11166C21.5482 7.32485 21.5482 7.53808 21.5482 7.75127C21.5482 14.2538 16.599 21.7462 7.5533 21.7462C4.76648 21.7462 2.17767 20.939 0 19.5381C0.395953 19.5837 0.776625 19.599 1.18781 19.599C3.48727 19.599 5.60405 18.8223 7.29441 17.4975C5.13197 17.4518 3.31978 16.0355 2.69541 14.0863C3 14.1319 3.30455 14.1624 3.62437 14.1624C4.06598 14.1624 4.50764 14.1015 4.91878 13.9949C2.66498 13.538 0.974578 11.5584 0.974578 9.1675V9.10661C1.62937 9.4721 2.39086 9.70052 3.19791 9.73094C1.87303 8.84767 1.00505 7.34008 1.00505 5.63449C1.00505 4.7208 1.24866 3.88324 1.67508 3.15227C4.09641 6.13703 7.73602 8.08624 11.8172 8.29947C11.7411 7.93399 11.6954 7.55332 11.6954 7.1726C11.6954 4.46191 13.8883 2.25381 16.6141 2.25381C18.0304 2.25381 19.3095 2.84772 20.208 3.80711C21.3197 3.59392 22.3857 3.18274 23.3299 2.6193C22.9643 3.76146 22.1877 4.72085 21.1674 5.32994C22.1573 5.22339 23.1167 4.94922 23.9999 4.56855C23.33 5.54313 22.4924 6.41111 21.533 7.11166Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'linkedin',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.70062 22H2.34688V7.97968H6.70062V22ZM4.52141 6.06718C3.12922 6.06718 2 4.91406 2 3.52187C2 2.85315 2.26565 2.21183 2.7385 1.73897C3.21136 1.26611 3.85269 1.00047 4.52141 1.00047C5.19012 1.00047 5.83145 1.26611 6.30431 1.73897C6.77716 2.21183 7.04281 2.85315 7.04281 3.52187C7.04281 4.91406 5.91313 6.06718 4.52141 6.06718ZM22.9953 22H18.6509V15.175C18.6509 13.5484 18.6181 11.4625 16.3873 11.4625C14.1237 11.4625 13.7769 13.2297 13.7769 15.0578V22H9.42781V7.97968H13.6034V9.89218H13.6644C14.2456 8.79062 15.6655 7.62812 17.7838 7.62812C22.19 7.62812 23 10.5297 23 14.2984V22H22.9953Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'delete',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4ZM6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19V7H6V19Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'propertyAdded',
    (color: string) => (
      <IconStyled width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" fill="var(--color-indigo-t3)" />
        <path
          d="M9 16.2L5.5 12.7C5.11 12.31 4.49 12.31 4.1 12.7C3.71 13.09 3.71 13.71 4.1 14.1L8.29 18.29C8.68 18.68 9.31 18.68 9.7 18.29L20.3 7.7C20.69 7.31 20.69 6.69 20.3 6.3C19.91 5.91 19.29 5.91 18.9 6.3L9 16.2Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'search',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" width="18" height="18">
        <defs />
        <path
          fill={color}
          d="M12.5 11h-.79l-.28-.27A6.471 6.471 0 0013 6.5 6.5 6.5 0 106.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L17.49 16l-4.99-5zm-6 0C4.01 11 2 8.99 2 6.5S4.01 2 6.5 2 11 4.01 11 6.5 8.99 11 6.5 11z"
        />
        <path
          fill={color}
          d="M12.5 11h-.79l-.28-.27A6.471 6.471 0 0013 6.5 6.5 6.5 0 106.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L17.49 16l-4.99-5zm-6 0C4.01 11 2 8.99 2 6.5S4.01 2 6.5 2 11 4.01 11 6.5 8.99 11 6.5 11z"
        />
      </IconStyled>
    ),
  ],
  [
    'phoneCall',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
        <path d="M13.5 2C17.9444 2 21.5 5.55556 21.5 10" stroke={color} stroke-width="2" />
        <path d="M13 6C15.5 6 17.5 8 17.5 10.5" stroke={color} stroke-width="2" />
        <path
          d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4741 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4018C21.1469 21.5901 20.9046 21.7335 20.6408 21.8227C20.3769 21.9119 20.0974 21.945 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77383 17.3146 6.72534 15.2661 5.19 12.85C3.49998 10.2412 2.44824 7.27097 2.12 4.17997C2.09501 3.90344 2.12788 3.62474 2.2165 3.3616C2.30513 3.09846 2.44757 2.85666 2.63477 2.6516C2.82196 2.44653 3.04981 2.28268 3.30379 2.1705C3.55778 2.05831 3.83234 2.00024 4.11 1.99997H7.11C7.59531 1.9952 8.06579 2.16705 8.43376 2.48351C8.80173 2.79996 9.04208 3.23942 9.11 3.71997C9.23662 4.68004 9.47145 5.6227 9.81 6.52997C9.94455 6.8879 9.97366 7.27689 9.89391 7.65086C9.81415 8.02482 9.62886 8.36809 9.36 8.63998L8.09 9.90997C9.51356 12.4135 11.5865 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9752 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0554 17.47 14.19C18.3773 14.5285 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
  [
    'chatBubble',
    (color: string) => (
      <IconStyled xmlns="http://www.w3.org/2000/svg" fill="none" width="24" height="24" viewBox="0 0 24 24">
        <path
          d="M7 20C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2V14C20 14.5304 19.7893 15.0391 19.4142 15.4142C19.0391 15.7893 18.5304 16 18 16H11.9L8.2 19.71C8 19.9 7.75 20 7.5 20H7ZM15 9V7H13V9H15ZM11 9V7H9V9H11ZM7 9V7H5V9H7Z"
          fill={color}
        />
      </IconStyled>
    ),
  ],
]);

const Icon: React.FC<ComponentProps> = ({ type, color = 'var(--color-indigo)' }) => {
  const iconGetter = map.get(type);
  return <>{iconGetter ? iconGetter(color) : ''}</>;
};

export default Icon;
